// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K7lG","left":"styles_left__16eiG","right":"styles_right__J4EGh","alert":"styles_alert__4i5DM"};